import { inject } from '@angular/core'
import { CanActivateChildFn, CanActivateFn } from '@angular/router'

import { AuthService } from './auth.service'
import { tap } from 'rxjs/operators'
import { from } from 'rxjs'

const returnURL = 'https://www.sportsengine.com'

export const affiliationGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)

  return from(authService.isAffiliationAdmin()).pipe(
    tap((isAffiliationAdmin) => {
      console.log('isAffiliationAdmin', isAffiliationAdmin)
      if (!isAffiliationAdmin) {
        window.location.href = returnURL
      }
    })
  )
}

// canActivateChild just calls canActivate
export const affiliationChildGuard: CanActivateChildFn = (route, state) =>
  affiliationGuard(route, state)
